import { render, staticRenderFns } from "./LightTable.vue?vue&type=template&id=5a7f277c&"
import script from "./LightTable.vue?vue&type=script&lang=js&"
export * from "./LightTable.vue?vue&type=script&lang=js&"
import style0 from "./LightTable.vue?vue&type=style&index=0&id=5a7f277c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports